import type { TFunction } from "i18next";

export const ERROR_CODE_UPLOAD = "UPLOAD_ERROR";

const GENERIC_ERROR = "Er liep iets mis. Probeer het later opnieuw aub.";

export const getGenericErrorMessage = (translate: TFunction): string =>
  translate("errors:error.generic", GENERIC_ERROR);
